export function isFontWeightBold(fontWeight: string): boolean {
    return /^bold|[56789]00$/.test(fontWeight);
}
